export default __webpack_public_path__ + "static/media/stage_confirmed.23c6783b.svg";